import React from 'react';
import Legend from './Legend';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

/** Ordinal scales map from strings to an Output type. */
export default function Ordinal(props) {
  return /*#__PURE__*/React.createElement(Legend, props);
}